import { Image, type ImageProps } from "expo-image";
import { StyleSheet } from "react-native";

type RapidRescueProps = Partial<ImageProps>;

export function RapidRescue(props: RapidRescueProps) {
  return (
    <Image
      source={require("./rapid-rescue.png")}
      alt="Rapid rescue"
      contentFit="contain"
      style={styles.image}
      {...props}
    />
  );
}

const styles = StyleSheet.create({
  image: {
    height: 85,
    width: 140,
  },
});
